import { render, staticRenderFns } from "./ListTab.vue?vue&type=template&id=44057667&"
import script from "./ListTab.vue?vue&type=script&lang=ts&"
export * from "./ListTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports